import { BehaviorSubject } from 'rxjs';

import { CureSheetEntitlement, ENTITLEMENT_UNKNOWN } from './cure-sheet-entitlement';

/**
 * The company's cure-sheet entitlement, shared by the NAV ITEM and the SCREEN.
 *
 * ONE SOURCE ON PURPOSE. If the nav decided separately it could offer a link to a
 * page that then says "not included" — worse than no link, and exactly the
 * disagreement a second copy of the rule invites.
 *
 * A MODULE-LEVEL SUBJECT RATHER THAN AN INJECTED SERVICE, deliberately.
 * MainLayoutComponent is constructed POSITIONALLY by eleven specs
 * (`new MainLayoutComponent(a, b, c, …)`), so adding a constructor parameter
 * breaks all of them at compile time — and rewriting eleven TestBeds to thread a
 * dependency they do not care about is a lot of churn for one boolean, plus
 * eleven more chances to get one wrong.
 *
 * The trade is real and worth naming: this is global state, so it is deliberately
 * ONE value with no per-instance variation, written in exactly one place
 * (CureSheetsService) and reset explicitly for tests. It is not a pattern to
 * extend — if a second thing ever wants to live here, that is the signal to do
 * the DI properly.
 */
export const cureSheetEntitlement$ = new BehaviorSubject<CureSheetEntitlement>(ENTITLEMENT_UNKNOWN);

/** Publish a fresh verdict. Called only by CureSheetsService. */
export function publishCureSheetEntitlement(entitlement: CureSheetEntitlement): void {
  cureSheetEntitlement$.next(entitlement);
}

/** Back to "nobody has said yes" — for specs, and on sign-out. */
export function resetCureSheetEntitlement(): void {
  cureSheetEntitlement$.next(ENTITLEMENT_UNKNOWN);
}
